import React, { createContext, useContext, useMemo, useState } from "react";
import apiClient from "../api/client";

const TOKEN_KEY = "irqgyp_auth_token";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("irqgyp_auth_user");
    return saved ? JSON.parse(saved) : null;
  });

  const login = async ({ username, password }) => {
    const response = await apiClient.post("/auth/login", { username, password });
    const payload = response?.data || {};
    const nextToken = payload.token || payload.accessToken || payload.jwt || "";
    const nextUser = payload.user || null;

    if (!nextToken) {
      throw new Error("Login response does not contain token");
    }

    localStorage.setItem(TOKEN_KEY, nextToken);
    localStorage.setItem("irqgyp_auth_user", JSON.stringify(nextUser));
    setToken(nextToken);
    setUser(nextUser);
    return payload;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem("irqgyp_auth_user");
    setToken("");
    setUser(null);
  };

  const value = useMemo(
    () => ({
      token,
      user,
      isAuthenticated: Boolean(token),
      login,
      logout,
    }),
    [token, user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};

export const authTokenStorageKey = TOKEN_KEY;
